import React from "react";
import styled, { css } from "styled-components";
import { fontSize } from "../common/styled-mixins";
import Message from "./Message";

const Container = styled.div`
  direction: ${({theme}) => theme.direction};
  font-size: ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ? fontSize(12) : fontSize(10)};
  line-height: 18px;
  color: #fff;
  background-color: tomato;
  border-radius: 15px;
  padding: 5px 10px;
  margin: 0 15px 10px 15px;

  ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" && css`
    text-align: center;
  `};
`;

type Props = {
  style?: Object,
  message: string
};

const ErrorMessage = (props: Props) => {
  if (process.env.REACT_APP_DEPLOY_TARGET === "irontrade") {
    return (
      <Container style={props.style}>
        {props.message}
      </Container>
    );
  }

  return (
    <Message error={props.message}/>
  );
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/Auth/ErrorMessage.js